module.exports = __webpack_public_path__ + "img/dst_summary_Image.7efff998.png";